export { default } from './getValidReactChildren';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/getValidReactChildren/index.js
// module id = 379
// module chunks = 22